/* @flow */
import cx from 'classnames';
import React, { Component } from 'react';

import LoadingIndicator from 'components/LoadingIndicator.jsx';
import Group from 'entities/Group';
import Organization from 'entities/Organization';
import View from 'components/View.jsx';

import styles from './styles/GroupView.css';

export class GroupView extends Component {
  static propTypes = {
    group: React.PropTypes.oneOfType([
      React.PropTypes.instanceOf(Group),
      React.PropTypes.instanceOf(Organization),
    ]),
    children: React.PropTypes.node.isRequired,
    accentColor: React.PropTypes.string.isRequired,
  };

  static childContextTypes = {
    // Can be an org at this point. If it's an org no one will use this context anyway, but we
    // have to allow for it here to prevent PropTypes errors.
    group: React.PropTypes.oneOfType([
      React.PropTypes.instanceOf(Group),
      React.PropTypes.instanceOf(Organization),
    ]),
  };


  getChildContext() {
    return {
      group: this.props.group,
    };
  }

  render() {
    const { children, group, accentColor } = this.props;
    const content = group ?
      React.cloneElement(children, { group }) :
      <LoadingIndicator className={styles.loading} />;

    return (
      <div className={styles.wrapper}>
        <div className={styles.topBorder} style={{ backgroundColor: accentColor }} />
        <View
          full
          className={cx(styles.this, this.props.className)}>
          {content}
        </View>
      </div>
    );
  }
}

export default GroupView;



// WEBPACK FOOTER //
// ./src/groups/components/GroupView.jsx